/**
 * Heading shown on every list-builder step: "Create <type> List".
 * Some source-type labels already end in "List" (e.g. "Smart List"), so blindly
 * appending " List" would render "Create Smart List List". Skip the suffix then.
 */
export const getListBuilderTitle = (typeLabel: string): string =>
	/\blist$/i.test(typeLabel.trim()) ? `Create ${typeLabel}` : `Create ${typeLabel} List`;
